
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import { radioType, selectType } from "../../interfaces";
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddIcon from '@mui/icons-material/Add';
import StarRateIcon from "@mui/icons-material/StarRate";

type propsData = {
    invalidInfoAlert: boolean
}

function PhoneNumbers({ invalidInfoAlert }: propsData) {

    const {
        phoneNumberData,
        setPhoneNumberData,
        formatPhoneNumber
    } = useGlobalContext();

    const [phoneNumberError, setPhoneNumberError] = useState<boolean>(false);

    useEffect(() => {
        if (invalidInfoAlert && phoneNumberData[0].text.length === 0) setPhoneNumberError(true);
        else setPhoneNumberError(false);
    }, [invalidInfoAlert])

    const findActivePhoneNumber = (phoneNumberData: selectType): string | undefined => {
        const activeType = phoneNumberData.category.find(item=> item.active);
        if (activeType) {
            return activeType.title
        }
    }

    const openSelectWindow = (numberData: selectType) => {
        setPhoneNumberData((phoneNumberData: selectType[]) =>  phoneNumberData.map((item: selectType) => item.id === numberData.id ? { ...item, isOpen: !item.isOpen } : {...item, isOpen: false}));
    }

    const onOptionClicked = (numberData: selectType, categoryData: radioType): void => {
        setPhoneNumberData((phoneNumberData: selectType[]) => phoneNumberData.map((item: selectType) => {
            if (item.id === numberData.id) {
                return {
                    ...item,
                    category: item.category.map((ctg: radioType) => ctg.id === categoryData.id ? {...ctg, active: true} : {
                        ...ctg,
                        active: false
                    }),
                    isOpen: false
                };
            }
            else {
                return { ...item }
            }
        }))
    }

    const changePhoneNumber = (value: string, numberData: selectType): void => {
        setPhoneNumberData((phoneNumberData: selectType[]) =>  phoneNumberData.map((item: selectType) => item.id === numberData.id ? { ...item, text: formatPhoneNumber(value) } : { ...item }));
    }

    const addPhoneNumber = (): void => {
        if (phoneNumberData.length < 5) {
            const lastId: number = phoneNumberData[phoneNumberData.length - 1].id + 1;
            setPhoneNumberData((phoneNumberData: selectType[]) => {
                return [
                    ...phoneNumberData,
                    {
                        id: lastId,
                        text: "",
                        isOpen: false,
                        category: [
                            {
                                id: parseInt(lastId + "1"),
                                title: "Office",
                                active: true
                            },
                            {
                                id: parseInt(lastId + "2"),
                                title: "Cell",
                                active: false
                            },
                            {
                                id: parseInt(lastId + "3"),
                                title: "Business",
                                active: false
                            }
                        ]
                    }
                ]
            });
        }
    }

    const deletePhoneNumber = (id: number): void => {
        setPhoneNumberData((phoneNumberData: selectType[]) => phoneNumberData.filter((item: selectType) => item.id !== id));
    }

    return(
        <div className="PhoneNumbers">
            <div className="form-phoneNumber-box">
                <label className="required" htmlFor="">Phone Number Type <span>Max 5</span> <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/> </label>
                <label htmlFor="">Number</label>
            </div>
                {
                    phoneNumberData.map((pn: selectType) =>
                    <div className="form-phoneNumber-box mrg-btm" key = { pn.id }>
                        <div className="phoneNumber-box-dropdown-container">
                            <div
                                className="phoneNumber-box-dropdown-header"
                                onClick = {() => openSelectWindow(pn)}
                                style = {{
                                    border: phoneNumberError ? "1px solid red" : "1px solid #ccc",
                                }}
                            >
                                { findActivePhoneNumber(pn) }
                                <ArrowDropDownIcon className="phoneNumber-box-dropdown-header-arrow" />
                            </div>
                            {
                                pn.isOpen && (
                                    <ul className="phoneNumber-box-dropdown-list">
                                        {
                                            pn.category.map((ctg: radioType) =>
                                                <li
                                                    className = "phoneNumber-box-dropdown-li"
                                                    onClick = {() => onOptionClicked(pn, ctg)}
                                                >
                                                    { ctg.title }
                                                </li>
                                            )
                                        }
                                    </ul>
                                )
                            }
                        </div>
                        <input
                            className = "phoneNumber-box-phoneNumber-input"
                            placeholder = "Enter Phone Number"
                            type = "tel"
                            value = { pn.text }
                            onChange = {(e) => changePhoneNumber(e.target.value, pn)}
                            style = {{
                                border: phoneNumberError ? "1px solid red" : "1px solid #ccc",
                            }}
                        />
                        <div className = "phoneNumber-box-delete">
                            {
                                pn.id === 1 ?
                                    <div
                                        className = "phoneNumber-box-add"
                                        onClick = { addPhoneNumber }
                                    >
                                        <AddIcon className = "box-addPhone-icon"/>
                                    </div>
                                    :
                                    <DeleteIcon className = "box-deletePhone-icon"  onClick = {() => deletePhoneNumber(pn.id)}/>
                            }
                        </div>
                    </div>
                )}
        </div>
    )
}

export default PhoneNumbers
